import {Form, Formik} from 'formik';
import {useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';
import * as Yup from 'yup';

import ShopLogo from '../../../assets/image/shopLogo.svg';
import FormikInput from '../../../components/formikFileds/input';
import {toEnglishDigits} from '../../../utilities/helper/toEnglishNumber';
import useCountDown from '../../../utilities/hooks/countDown/useCountDown';
import AutoMationSms from '../AutoMationSms';
import UseSendCode from '../hooks/useSendCode';
import UseSendConfirmation from '../hooks/useSendConfirmation';

const LoginSchema = Yup.object().shape({
  confirmCode: Yup.string().required('کد اجباریست'),
});

export interface IConfirmation {
  phoneNumber: string;
  confirmCode: string;
}
const Confirmation = () => {
  const location = useLocation();
  const mobile = location.state?.mobile;

  const {currentMinutes, currentSeconds, startHandler, isRunning} =
    useCountDown();
  const {mutate} = UseSendConfirmation();
  const {isLoading: sendCodeLoading, mutate: sendCodeMutate} = UseSendCode();

  useEffect(() => {
    startHandler();
  }, []);
  const initialValues: IConfirmation = {phoneNumber: mobile, confirmCode: ''};

  const sendResendOtpHandler = () => {
    sendCodeMutate({mobile: mobile, app: 'supplier', country_code: '98'});
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-4">
      <div className="flex justify-center w-100">
        <img src={ShopLogo} alt={'ShopLogo'} />
      </div>
      <div className="flex flex-col w-[70%] justify-center gap-2">
        <h1 className="p-0 m-0 text-gray-700 text-md font-Regular">ورود</h1>
        <p className="p-0 m-0 text-sm text-gray-700 font-Medium">
          جهت ورود به فروشگاه مزرعه کد تأیید را وارد کنید.
        </p>
      </div>
      <Formik
        onSubmit={async values => {
          mutate({
            country_code: '98',
            mobile,
            otp_code: values.confirmCode,
            app: 'supplier',
          });
        }}
        initialValues={initialValues}
        validationSchema={LoginSchema}
      >
        {({values, setFieldValue, submitForm}) => {
          useEffect(() => {
            if (values.confirmCode.length === 5) {
              submitForm();
            }
          }, [values.confirmCode, submitForm]);

          return (
            <Form className="d-flex w-[60%] flex-col items-center gap-3">
              <AutoMationSms
                values={values}
                setFieldValue={setFieldValue}
                handleSubmit={submitForm}
              />
              <FormikInput
                disabled
                name="phoneNumber"
                label="شماره تلفن"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setFieldValue('phoneNumber', e.target.value);
                }}
                required={!values.phoneNumber}
              />
              <FormikInput
                type="tel"
                autoComplete="one-time-code"
                inputMode="numeric"
                name="confirmCode"
                label="کد تأیید"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const formattedCode = toEnglishDigits(e.target.value)
                    .replace(/\D/g, '')
                    .slice(0, 5); // limit the user to only able to type 5 numbers
                  setFieldValue('confirmCode', formattedCode);
                }}
                required={!values.confirmCode}
              />
            </Form>
          );
        }}
      </Formik>

      <div className="flex flex-col w-[60%]">
        <div className="flex items-center w-full gap-2">
          <button
            className=" disabled:text-gray-600 text-farm-shop-500 text-md font-Medium"
            onClick={sendResendOtpHandler}
            disabled={isRunning || sendCodeLoading}
          >
            ارسال مجدد کد
          </button>
          <div className="flex items-center gap-2 text-gray-500 text-md font-Medium">
            تا
            <span className="text-gray-950 text-md font-Medium">
              {currentSeconds} : {currentMinutes}
            </span>
          </div>
        </div>
        <Link className="no-underline text-farm-shop-500" to={'/auth/login'}>
          تغییر شماره
        </Link>
      </div>
    </div>
  );
};

export default Confirmation;
